/**
 * @generated SignedSource<<8f867a8ac4d12561fed9b7a1c3e40244>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type analytics_init$data = {
  readonly isFlexhireTeam: boolean | null | undefined;
  readonly realUser: {
    readonly isFlexhireTeam: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"analytics_setUserInfo">;
  readonly " $fragmentType": "analytics_init";
};
export type analytics_init$key = {
  readonly " $data"?: analytics_init$data;
  readonly " $fragmentSpreads": FragmentRefs<"analytics_init">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "analytics_init"
};

(node as any).hash = "867d21f20d4890854c51c7558a591d68";

export default node;
